import React, {useState} from 'react';
import {formatAttendanceStatus, formatSimpleDate} from '../../utils/helpers';

/**
 * Component for displaying attendance records in a table
 *
 * @param {Object} props
 * @param {Array} props.attendanceRecords - Array of attendance records
 */
const AttendanceRecords = ({attendanceRecords}) => {
    const [filterStatus, setFilterStatus] = useState("all"); // all, present, absent

    // Filter attendance records based on status
    const getFilteredAttendanceRecords = () => {
        if (filterStatus === "all") return attendanceRecords;
        if (filterStatus === "present") return attendanceRecords.filter(rec => rec.present);
        if (filterStatus === "absent") return attendanceRecords.filter(rec => !rec.present);
        return attendanceRecords;
    };

    if (!attendanceRecords || attendanceRecords.length === 0) {
        return null;
    }

    return (
        <div className="bg-white shadow overflow-hidden sm:rounded-lg mt-6">
            <div className="px-4 py-5 sm:px-6 bg-gray-50 flex justify-between items-center">
                <h2 className="text-lg leading-6 font-medium text-gray-900">Attendance History</h2>

                <div className="flex items-center space-x-2">
                    <span className="text-sm text-gray-500">Filter:</span>
                    <select
                        className="block w-32 py-1.5 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                    >
                        <option value="all">All</option>
                        <option value="present">Present</option>
                        <option value="absent">Absent</option>
                    </select>
                </div>
            </div>

            <div className="border-t border-gray-200">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                        <tr>
                            <th scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Date
                            </th>
                            <th scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                            </th>
                            <th scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Day of Week
                            </th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {getFilteredAttendanceRecords().sort((a, b) => new Date(b.date) - new Date(a.date)).map((record, index) => (
                            <tr key={index}
                                className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    {formatSimpleDate(record.date)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {formatAttendanceStatus(record.present)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {new Date(record.date).toLocaleDateString(undefined, {weekday: 'long'})}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                {getFilteredAttendanceRecords().length === 0 && (
                    <div className="py-6 text-center">
                        <p className="text-sm text-gray-500">No attendance records matching the selected filter.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AttendanceRecords;